/** Parsed image evidence used by the dashboard; no server-provided URL is trusted. */
export type NoteImageMetadata =
  | { readonly kind: "absent" }
  | { readonly kind: "invalid" }
  | {
      readonly kind: "ready";
      readonly id: string;
      readonly width: number;
      readonly height: number;
      readonly reconstructed: boolean;
    };

/** Parse only the stored image fields that the dashboard needs to display. */
export function parseNoteImage(value: unknown): NoteImageMetadata {
  if (value === null || value === undefined) return { kind: "absent" };
  if (
    typeof value !== "object" ||
    !("id" in value) ||
    typeof value.id !== "string" ||
    value.id.length === 0 ||
    !("width" in value) ||
    !imageDimension(value.width) ||
    !("height" in value) ||
    !imageDimension(value.height)
  )
    return { kind: "invalid" };
  const capture = "capture" in value ? value.capture : null;
  return {
    kind: "ready",
    id: value.id,
    width: value.width,
    height: value.height,
    reconstructed:
      typeof capture === "object" &&
      capture !== null &&
      "method" in capture &&
      capture.method === "dom-reconstruction",
  };
}

/** Build a same-origin private read path from resource identifiers, never a URL. */
export function noteImagePath(siteId: string, noteId: string): string {
  return `/v1/appnotes/sites/${encodeURIComponent(siteId)}/notes/${encodeURIComponent(noteId)}/screenshot`;
}

function imageDimension(value: unknown): value is number {
  return typeof value === "number" && Number.isSafeInteger(value) && value > 0;
}
